module.exports = __webpack_public_path__ + "img/plantation64_ua.7d52f0ff.webp";